import { v4 as uuid } from 'uuid';

import { format, getZonedDate } from '@eika-infrastruktur/date';
import ValutaFilter from '@eika-infrastruktur/ui-valuta-filter';
import { FormattedTransaction, FormattedTransactions } from '@eika/transaction-list/src/TransactionList';

import type { InvoiceDocument } from '../../generated-types';
import TranslationsConfigType from '../../translations/translationType';

const labelDateFormat = 'dd.MM';
const labelYear = 'yyyy';

const getDate = (invoice: InvoiceDocument) => {
    return getZonedDate(invoice.date);
};

const getPreviousTransactionDate = (invoice: InvoiceDocument, invoices: InvoiceDocument[]) => {
    const previous = invoices.indexOf(invoice) - 1;
    if (previous < 0 || invoices[previous] === null) return null;
    return getDate(invoices[previous]);
};

const isNewYearGroup = (invoice: InvoiceDocument, invoices: InvoiceDocument[]): boolean => {
    const prevDate = getPreviousTransactionDate(invoice, invoices);
    const date = getDate(invoice);
    return prevDate === null || date.getFullYear() !== prevDate.getFullYear();
};

const getYearLabel = (t: InvoiceDocument) => {
    return format(getDate(t), labelYear);
};

const formatTransaction = (
    invoice: InvoiceDocument,
    onClick: (id: string) => void,
    translations: TranslationsConfigType,
): FormattedTransaction => ({
    id: invoice.id.value ?? uuid(),
    description: invoice.name,
    date: format(invoice.date, labelDateFormat),
    amount: ValutaFilter(invoice.amount),
    balance: translations.invoiceArchive.status[invoice.status],
    reservation: false,
    deposit: false,
    onClick,
});

export default function formatInvoices(
    invoices: InvoiceDocument[],
    onClick: (id: string) => void,
    translations: TranslationsConfigType,
): FormattedTransactions[] {
    const initialValue: FormattedTransactions[] = [];

    return invoices.reduce((map, invoice) => {
        if (isNewYearGroup(invoice, invoices)) {
            const yearLabel = getYearLabel(invoice);
            map.push({ id: yearLabel, label: yearLabel, transactions: [] });
        }
        map[map.length - 1].transactions.push(formatTransaction(invoice, onClick, translations));
        return map;
    }, initialValue);
}
